import gql from 'graphql-tag';

export default gql`
    query GetJobSummaryInfo($jobId: Int) {
        getJobSummaryInfo(jobId: $jobId) {
            jobSummaryId
            jobId
            proppantId
            proppantName
            jobName
            lofaId
            sandPo
            transportationPo
            lofaName
        }
    }
`;
